import { toast } from "react-toastify";

export const validateStep1 = (data) => {
  if (!data.date_sabt) {
    toast.error("تاریخ ثبت را وارد کنید");
    return false;
  }
  if (!data.time_sabt) {
    toast.error("ساعت ثبت را وارد کنید");
    return false;
  }
  if (!data.date_amade) {
    toast.error("تاریخ آماده‌سازی را وارد کنید");
    return false;
  }
  if (!data.time_amade) {
    toast.error("ساعت آماده‌سازی را وارد کنید");
    return false;
  }
  if (!data.date_tahvil) {
    toast.error("تاریخ تحویل را وارد کنید");
    return false;
  }
  if (!data.time_tahvil) {
    toast.error("ساعت تحویل را وارد کنید");
    return false;
  }
  if (!data.id_moshtari) {
    toast.error("مشتری را انتخاب کنید");
    return false;
  }
  return true;
};

export const validateStep2 = (data) => {
  if (!data.products || data.products.length === 0) {
    toast.error("حداقل یک محصول باید به جدول اضافه شود");
    return false;
  }
  for (const [index, item] of data?.products?.entries()) {
    if (!item.te || Number(item.te) === 0) {
      toast.error(`تعداد محصول "${item.product_name}" نمی‌تواند صفر باشد.`);
      return false;
    }
  }
  return true;
};

export const validateStep3 = (data) => {
  if (!data.services || data.services.length === 0) {
    toast.error("حداقل یک خدمت باید به جدول اضافه شود");
    return false;
  }
  return true;
};

export const validateStep4 = (data) => {
  if (!data.cars || data.cars.length === 0) {
    toast.error("حداقل یک راننده باید به جدول اضافه شود");
    return false;
  }
  return true;
};